export const getShippingMethodKey = (
  method?: {
    carrier_code?: string;
    method_code?: string | null;
  } | null
) => `${method?.carrier_code || ''}_${method?.method_code || ''}`;
